import Vue from 'vue';
import VueSlider from 'vue-slider-component';
// import 'vue-slider-component/lib/theme/material.scss';
Vue.component('VueSlider', VueSlider);
